"use client";

import { useEffect } from "react";

// Gửi lỗi trình duyệt về server (spec admin A2) để admin xem ở /admin/errors.

type Report = { kind: "window" | "promise" | "boundary"; message: string; stack?: string; digest?: string };

const sent = new Set<string>();

export function reportClientError(r: Report) {
  // Lỗi của extension trình duyệt (chrome-extension://…) không phải lỗi KyFlow.
  if (r.stack && /(chrome|moz|safari-web)-extension:\/\//.test(r.stack)) return;
  // Cùng một lỗi chỉ gửi một lần mỗi lần mở trang (lỗi lặp trong vòng render không spam server).
  const key = `${r.kind}|${r.message}`;
  if (sent.has(key) || sent.size > 20) return;
  sent.add(key);
  const body = JSON.stringify({ ...r, message: r.message.slice(0, 4_000), stack: r.stack?.slice(0, 16_000), path: location.pathname + location.search });
  try {
    if (!navigator.sendBeacon?.("/api/errors", new Blob([body], { type: "application/json" }))) {
      void fetch("/api/errors", { method: "POST", body, keepalive: true, headers: { "Content-Type": "application/json" } }).catch(() => {});
    }
  } catch {
    // bỏ qua
  }
}

export function ErrorReporter() {
  useEffect(() => {
    const onError = (e: ErrorEvent) => {
      // Lỗi tải script của extension / trang khác: không có thông tin gì để sửa.
      if (!e.message || e.message === "Script error.") return;
      reportClientError({ kind: "window", message: e.message, stack: e.error instanceof Error ? e.error.stack : `${e.filename}:${e.lineno}:${e.colno}` });
    };
    const onRejection = (e: PromiseRejectionEvent) => {
      const r = e.reason;
      // Người dùng bấm Dừng / chuyển trang → AbortError, không phải lỗi.
      if (r instanceof DOMException && r.name === "AbortError") return;
      reportClientError({ kind: "promise", message: r instanceof Error ? r.message : String(r), stack: r instanceof Error ? r.stack : undefined });
    };
    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);
  return null;
}
